import { render } from "./thankYouReject.vue?vue&type=template&id=ebf009a0&scoped=true"
import script from "./thankYouReject.vue?vue&type=script&lang=js"
export * from "./thankYouReject.vue?vue&type=script&lang=js"

import "./thankYouReject.vue?vue&type=style&index=0&id=ebf009a0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf009a0"]])

export default __exports__